import { uuid } from './utils'

export default {
  name: 'workshop',
  columns: [
    {
      name: 'todo',
      tasks: [
        {
          description: '',
          name: 'first task1',
          id: uuid(),
          userAssigned: null,
        },
        {
          description: '',
          name: 'second task1',
          id: uuid(),
          userAssigned: null,
        },
        {
          description: '',
          name: 'and third1',
          id: uuid(),
          userAssigned: null,
        },
      ],
    },
    {
      name: 'in-progress',
      tasks: [
        {
          description: '',
          name: 'first task2',
          id: uuid(),
          userAssigned: null,
        },
      ],
    },
    {
      name: 'done',
      tasks: [
        {
          description: '',
          name: 'first task3',
          id: uuid(),
          userAssigned: null,
        },
      ],
    },
  ],
}
